import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app/app-routing.module';
import Quill from 'quill';
import { environment } from './environments/environment';
import ImageResize from 'quill-image-resizor';
import { AuthService } from './app/auth';
import { AuthStorage } from './app/auth-storage';
import { provideTranslateService } from '@ngx-translate/core';
import { Global } from './app/services/global';
import { provideAppInitializer } from '@angular/core';
import { HTTP } from './app/services/http';

(ImageResize as any).Quill = Quill;
Quill.register('modules/imageResize', ImageResize, true);

bootstrapApplication(AppComponent, {
  providers: [
    AuthService,
    // provideAppInitializer(() => {
    //   try {
    //     return HTTP.get('notifications')
    //   } catch (error) {
    //     return Promise.resolve([]);
    //   }
    // }),
    provideRouter(routes),
    provideTranslateService({
      fallbackLang: 'en',
    }),
    { provide: Global, useValue: Global },
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.apiUrl],
        sendAccessToken: true,
      },
    }),
    // Must stay after provideOAuthClient(): that provides OAuthStorage itself
    // (defaulting to sessionStorage), so an earlier entry is silently overridden.
    { provide: OAuthStorage, useFactory: () => new AuthStorage() },
  ],
}).catch(err => console.error(err));